var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 8,
    fill: "#20C576"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.33301H8.16665C7.70641 7.33301 7.33331 7.7061 7.33331 8.16634V11.4997C7.33331 11.9599 7.70641 12.333 8.16665 12.333H11.5C11.9602 12.333 12.3333 11.9599 12.3333 11.4997V8.16634C12.3333 7.7061 11.9602 7.33301 11.5 7.33301Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.667H8.16665C7.70641 15.667 7.33331 16.0401 7.33331 16.5003V19.8337C7.33331 20.2939 7.70641 20.667 8.16665 20.667H11.5C11.9602 20.667 12.3333 20.2939 12.3333 19.8337V16.5003C12.3333 16.0401 11.9602 15.667 11.5 15.667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8334 15.667H16.5C16.0398 15.667 15.6667 16.0401 15.6667 16.5003V19.8337C15.6667 20.2939 16.0398 20.667 16.5 20.667H19.8334C20.2936 20.667 20.6667 20.2939 20.6667 19.8337V16.5003C20.6667 16.0401 20.2936 15.667 19.8334 15.667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 9.83301H20.6667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1667 7.33301V12.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.6ba82a8514251db731892b6f90eb7343.svg";
export { ForwardRef as ReactComponent };